import React from 'react'

const UserLoader = () => <div className='spinner-container'><span className="loading-spinner"></span></div>
export default UserLoader;